export enum PredefinedAchievementScenario {
    
    TEAMS_ONBOARDING = "teams-onboarding",
    
    MEET_GENERAL= "meet-general"
}